import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4bf5c2e9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4bf5c2e9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf5c2e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf5c2e9')) {
      api.createRecord('4bf5c2e9', component.options)
    } else {
      api.reload('4bf5c2e9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4bf5c2e9&scoped=true", function () {
      api.rerender('4bf5c2e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjGraph/index.vue"
export default component.exports